import React, { useContext } from 'react';
import { CurrentCaseContext } from './CurrentCaseContext';
import { useCurrentCase } from 'hooks/useCurrentCase';

export type CurrentCaseContextValue = ReturnType<typeof useCurrentCase>;

export const CurrentCaseProvider = ({ children }: { children: React.ReactNode }) => {
  const currentCaseData = useCurrentCase();

  return (
    <CurrentCaseContext.Provider value={currentCaseData}>{children}</CurrentCaseContext.Provider>
  );
};

export const useCurrentCaseContext = (): CurrentCaseContextValue => {
  const context = useContext(CurrentCaseContext);

  if (!context) {
    throw new Error('useCurrentCaseContext must be used within a CurrentCaseProvider');
  }

  return context;
};
